import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AuthService from "../services/AuthService";
import { useUser } from "../contexts/UserContext"; // adjust path if needed

const AdminLogout = () => {
  const navigate = useNavigate();
  const { setUser } = useUser();

  useEffect(() => {
    const performLogout = async () => {
      try {
        await AuthService.logout();
        navigate("/xl-login"); // Redirect after logout
      } catch (error) {
        console.error("Logout failed:", error);
        navigate("/xl-login"); // Still redirect even if logout failed
      } finally {
        setUser(null); // clear user context
        navigate("/login");
      }
    };

    performLogout();
  }, [navigate]);

  return null; // nothing to show
};

export default AdminLogout;
